import React, { OlHTMLAttributes } from 'react'

import { overrideOptional } from '@emico/overrides'

const UnorderedList = (props: OlHTMLAttributes<HTMLUListElement>) => (
  <ul {...props} />
)

export default overrideOptional(UnorderedList)
